import { render, staticRenderFns } from "./MediaContent.vue?vue&type=template&id=e6b1b03e&scoped=true&lang=pug&"
import script from "./MediaContent.vue?vue&type=script&lang=js&"
export * from "./MediaContent.vue?vue&type=script&lang=js&"
import style0 from "./MediaContent.vue?vue&type=style&index=0&id=e6b1b03e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b1b03e",
  null
  
)

/* custom blocks */
import block0 from "./MediaContent.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports